"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReadableProviderName = void 0;
const providers_1 = require("root/src/shared/@types/providers");
function getReadableProviderName(provider) {
    switch (provider) {
        case providers_1.Provider.Twitch:
            return 'Twitch';
        case providers_1.Provider.Google:
            return 'YouTube';
        case providers_1.Provider.TikTok:
            return 'TikTok';
        default:
            throw new Error(`Unknown provider ${provider}`);
    }
}
exports.getReadableProviderName = getReadableProviderName;
